import React, { FormEvent, useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Chip,
  useMediaQuery,
  Alert,
  AlertTitle,
} from "@mui/material";
import CommonModal from "./HWSubmitModal";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: { optionId: number; option: string; correctAnswer: string }[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface Layout12Props {
  Questions: Question[];
  currentQuestionIndex: number;
  setCurrentQuestionIndex: React.Dispatch<React.SetStateAction<number>>;
  layout11length: number;
  sectionName: string;
}

interface QuestionState {
  questionIndex: number;
  draggedWord: string | null;
  droppedArticle: string | null;
}

const Layout12: React.FC<Layout12Props> = ({
  Questions,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  layout11length,
  sectionName,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  //console.log("Layout6Questions", Questions);
  const currentQuestion = Questions[currentQuestionIndex - layout11length];
  const sentences = currentQuestion?.question.split("<br>");
  // console.log("Current Question", currentQuestion);
  const questionText = sentences[0];
  const mediaUrl = currentQuestion.mediaUrl;
  //console.log("Media URL", mediaUrl);
  const word = sentences[1];
  // console.log("Word", word);
  const correctArticle = currentQuestion.optionsList[0].option;
  // console.log("CorrectArticle", correctArticle);
  const [modalOpen, setModalOpen] = useState(false);
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  // const [draggedWord, setDraggedWord] = useState<string | null>(null);
  // const [droppedArticle, setDroppedArticle] = useState<string | null>(null);
  // const [questionStates, setQuestionStates] = useState<QuestionState[]>(
  //   Questions.map((_, index) => ({
  //     questionIndex: index,
  //     draggedWord: null,
  //     droppedArticle: null,
  //   }))
  // );
  const [questionStates, setQuestionStates] = useState<QuestionState[]>(() => {
    const storageKey = `droppedItemsLayout12_${currentQuestion.questionPaperId}`;
    const savedStates = localStorage.getItem(storageKey);
    return savedStates
      ? JSON.parse(savedStates)
      : Questions.map((_, index) => ({
          questionIndex: index,
          draggedWord: null,
          droppedArticle: null,
        }));
  });

  // const currentQuestion = Questions[currentQuestionIndex - layout11length];
  const questionState = questionStates[currentQuestionIndex - layout11length];

  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();

  const handleFormSubmit = () => {
    // setIsCorrectSubmission(isCorrectSubmission);
    // const isCorrect = droppedArticle === correctArticle;
    setShowAlert(true);
    const isCorrect = questionState.droppedArticle === correctArticle;
    setIsCorrectSubmission(isCorrect);
    // console.log("questionState.droppedArticle ", questionState.droppedArticle);

    if (isCorrect) {
      setIsCorrectSubmission(true);
      // playCorrectSound();
      setModalOpen(true);
      //console.log("Answer is correct");
      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );

      if (questionIndex !== -1) {
        // Update the existing score
        const updatedScores = [...questionScores];
        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: currentQuestion.marks,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };

        setQuestionScores(updatedScores);
      } else {
        // Add a new score for the question
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else {
      setIsCorrectSubmission(false);
      // playInCorrectSound();
      setModalOpen(true);
      setQuestionScores((prevScores) => [
        ...prevScores,
        {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: 0,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        },
      ]);
    }

    const updatedExamAnswer = {
      questionBankId: currentQuestion.questionBankId,
      acutalOptionValue: correctArticle,
      enteredOptionValue: questionState.droppedArticle || "",
    };

    // Reset selectedOptions for the next question
    questionState.droppedArticle = "";

    // Check if there is already an answer for the current question
    const existingAnswerIndex = examAnswers.findIndex(
      (answer) => answer.questionBankId === currentQuestion.questionBankId
    );

    if (existingAnswerIndex !== -1) {
      // If an answer already exists, update the existing one
      setExamAnswers((prevAnswers) =>
        prevAnswers.map((answer, index) =>
          index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
        )
      );
    } else {
      // If there is no existing answer, add the new answer
      setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
    }

    // console.log("updatedExamAnswer ", updatedExamAnswer);
    // console.log("examAnswers  ", examAnswers);
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  // const handleContinue = () => {
  //   setCurrentQuestionIndex((prevIndex) =>
  //     Math.min(prevIndex + 1, Questions.length - 1)
  //   );
  //   setModalOpen(false);
  // };
  // const handleContinue = () => {
  //   setCurrentQuestionIndex((prevIndex) =>
  //     Math.min(prevIndex + 1, Questions.length - 1 + layout11length)
  //   );
  //   setModalOpen(false);
  //   setDraggedWord(null);
  //   setDroppedArticle(null);
  // };
  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1 + layout11length)
    );
    setModalOpen(false);

    // Reset the state for the current question
    // setQuestionStates((prevStates) =>
    //   prevStates.map((state) =>
    //     state.questionIndex === currentQuestionIndex - layout11length
    //       ? { ...state, draggedWord: null, droppedArticle: null }
    //       : state
    //   )
    // );
  };

  const handleRetry = () => {
    setModalOpen(false);
    setQuestionStates((prevStates) =>
      prevStates.map((state) =>
        state.questionIndex === currentQuestionIndex - layout11length
          ? { ...state, draggedWord: null, droppedArticle: null }
          : state
      )
    );
  };

  const allowDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  // const drag = (event: React.DragEvent<HTMLImageElement>) => {
  //   setDraggedWord(event.currentTarget.id);
  // };
  // const drag = (event: React.DragEvent<HTMLImageElement>) => {
  //   const draggedWord = event.currentTarget.id;
  //   setQuestionStates((prevStates) =>
  //     prevStates.map((state) =>
  //       state.questionIndex === currentQuestionIndex - layout11length
  //         ? { ...state, draggedWord }
  //         : state
  //     )
  //   );
  // };

  // const drop = (event: React.DragEvent<HTMLDivElement>, article: string) => {
  //   event.preventDefault();
  //   // Check if the dropped word is correct (compare with correctArticle)
  //   const isCorrect = article === correctArticle;
  //   setIsCorrectSubmission(isCorrect);

  //   if (isCorrect) {
  //     playCorrectSound();
  //   } else {
  //     playInCorrectSound();
  //   }

  //   setModalOpen(true);
  // };
  // const drop = (event: React.DragEvent<HTMLDivElement>, article: string) => {
  //   event.preventDefault();
  //   setDroppedArticle(article);
  // };
  // const drop = (event: React.DragEvent<HTMLDivElement>, article: string) => {
  //   event.preventDefault();
  //   setQuestionStates((prevStates) =>
  //     prevStates.map((state) =>
  //       state.questionIndex === currentQuestionIndex - layout11length
  //         ? { ...state, droppedArticle: article }
  //         : state
  //     )
  //   );
  // };

  const drag: React.DragEventHandler<HTMLImageElement> = (event) => {
    const draggedWord = "image"; // In your case, "image" seems to be the word
    setQuestionStates((prevStates) =>
      prevStates.map((state) =>
        state.questionIndex === currentQuestionIndex - layout11length
          ? { ...state, draggedWord }
          : state
      )
    );
  };

  const drop = (event: React.DragEvent<HTMLDivElement>, article: string) => {
    event.preventDefault();
    const draggedWord = questionState.draggedWord;
    if (draggedWord) {
      setQuestionStates((prevStates) =>
        prevStates.map((state) =>
          state.questionIndex === currentQuestionIndex - layout11length
            ? { ...state, droppedArticle: article }
            : state
        )
      );
    }
  };

  const touchStart = (
    event: React.TouchEvent<HTMLImageElement>,
    word: string
  ) => {
    setQuestionStates((prevStates) =>
      prevStates.map((state) =>
        state.questionIndex === currentQuestionIndex - layout11length
          ? { ...state, draggedWord: word }
          : state
      )
    );
  };

  // const touchEnd = (
  //   event: React.TouchEvent<HTMLDivElement>,
  //   article: string
  // ) => {
  //   event.preventDefault();
  //   // Get the dragged word from the question state
  //   const draggedWord = questionState.draggedWord;
  //   if (draggedWord) {
  //     // Set the droppedArticle in the question state
  //     setQuestionStates((prevStates) =>
  //       prevStates.map((state) =>
  //         state.questionIndex === currentQuestionIndex - layout11length
  //           ? { ...state, droppedArticle: article }
  //           : state
  //       )
  //     );
  //   }
  // };
  const touchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault();
    // Get the dragged word from the question state
    const draggedWord = questionState.draggedWord;
    if (draggedWord) {
      const touchX = event.changedTouches[0].clientX;
      const touchY = event.changedTouches[0].clientY;
      const dropBoxA = document.getElementById("dropBoxA");
      const dropBoxAn = document.getElementById("dropBoxAn");

      if (dropBoxA && dropBoxAn) {
        const rectA = dropBoxA.getBoundingClientRect();
        const rectAn = dropBoxAn.getBoundingClientRect();

        // Check if the touch event is inside the bounds of dropBoxA or dropBoxAn
        const isInsideA =
          touchX >= rectA.left &&
          touchX <= rectA.right &&
          touchY >= rectA.top &&
          touchY <= rectA.bottom;

        const isInsideAn =
          touchX >= rectAn.left &&
          touchX <= rectAn.right &&
          touchY >= rectAn.top &&
          touchY <= rectAn.bottom;

        // Set the droppedArticle in the question state based on the result
        const droppedArticle = isInsideA ? "a" : isInsideAn ? "an" : null;

        setQuestionStates((prevStates) =>
          prevStates.map((state) =>
            state.questionIndex === currentQuestionIndex - layout11length
              ? { ...state, droppedArticle }
              : state
          )
        );
      }
    }
  };

  const resetQuestion = () => {
    setQuestionStates((prevStates) =>
      prevStates.map((state) =>
        state.questionIndex === currentQuestionIndex - layout11length
          ? { ...state, draggedWord: null, droppedArticle: null }
          : state
      )
    );
  };

  useEffect(() => {
    const storageKey = `droppedItemsLayout12_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(questionStates));
  }, [questionStates]);

  const correctOptions = currentQuestion?.optionsList?.map(
    (option: { option: any }) => option.option
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        marginTop: isViewMode ? "5%" : isTablet ? "15%" : "auto",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      {currentQuestion && (
        <Card
          variant="outlined"
          sx={{
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
            pointerEvents: isViewMode ? "none" : "auto",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                paddingBottom: "0px",
              }}
              style={{ userSelect: "none" }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: isMobile ? "100%" : "110%",
                }}
              >
                {questionText}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  marginTop: "2px",
                }}
              >
                {/* Implement the drag-and-drop here */}

                <img
                  id="image"
                  src={mediaUrl}
                  alt={word}
                  draggable="true"
                  onDragStart={drag} // Add mouse drag event
                  onTouchStart={(e) => touchStart(e, "image")} // Add touch start event
                  onTouchEnd={(e) => touchEnd(e)}
                  width="200"
                  style={{
                    width: "100px",
                    height: "100px",
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  marginTop: "5px",
                }}
              >
                <Box
                  id="dropBoxA"
                  className="dropBox"
                  onDrop={(event) => drop(event, "a")}
                  onDragOver={allowDrop}
                  onTouchEnd={(e) => touchEnd(e)}
                  sx={{
                    width: "100px",
                    height: "100px",
                    border: "2px solid",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column-reverse",
                    alignItems: "center",
                    marginRight: "20px",
                  }}
                >
                  {questionState.droppedArticle === "a" &&
                    questionState.draggedWord === "image" && (
                      <img
                        src={mediaUrl}
                        alt={word}
                        draggable="true"
                        onDragStart={drag}
                        width="100"
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      />
                    )}
                  <Typography variant="h6">a</Typography>
                </Box>
                <Box
                  id="dropBoxAn"
                  className="dropBox"
                  onDrop={(event) => drop(event, "an")}
                  onDragOver={allowDrop}
                  onTouchEnd={(e) => touchEnd(e)}
                  sx={{
                    width: "100px",
                    height: "100px",
                    border: "2px solid",
                    borderRadius: "4px",
                    display: "flex",
                    flexDirection: "column-reverse",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {questionState.droppedArticle === "an" &&
                    questionState.draggedWord === "image" && (
                      <img
                        src={mediaUrl}
                        alt={word}
                        draggable="true"
                        onDragStart={drag}
                        width="100"
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      />
                    )}
                  <Typography variant="h6">an</Typography>
                </Box>
              </Box>
              {isViewMode && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    margin: 1,
                  }}
                >
                  {correctOptions?.map((option, index) => (
                    <Chip
                      key={index}
                      label={`Correct article : "${option}"`}
                      style={{ margin: "4px" }}
                      sx={{ backgroundColor: "#81c784" }}
                    />
                  ))}
                </Box>
              )}
              {!isViewMode && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    marginTop: "5px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "16px" }}
                    onClick={handleFormSubmit}
                  >
                    Submit
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{ marginTop: "16px", marginLeft: "10px" }}
                    onClick={resetQuestion}
                  >
                    Reset
                  </Button>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default Layout12;
